// // ServicesSection.jsx
// import React, { useState } from "react";
// import "./services.mobile.css"; // <-- updated CSS with flip styles
// import { Link } from "react-router-dom";


// const ServicesSection = () => {
//   const services = [
//     {
//       icon: "bi-house-gear", // alt: bi-house or bi-tools for generic services
//       title: "Home & Kitchen Services",
//       desc: "Book plumbers, electricians, cleaners, and kitchen help with tracking.",
//     },

//     // NEW: Quick Drop (Transport)
//     {
//       icon: "bi-truck", 
//       title: "Quick Drop (Transport)",
//       desc: "On-demand pick-up & drop for parcels or errands within the city.",
//     },
//     {
//       icon: "bi-shield-lock",
//       title: "Security & Visitor Pass",
//       desc: "Issue digital entry passes, verify visitors, and track logs.",
//     },
//     {
//       icon: "bi-megaphone",
//       title: "Notices & Announcements",
//       desc: "Publish society-wide notices with delivery & read receipts.",
//     },
//     {
//       icon: "bi-calendar-event",
//       title: "Events & RSVPs",
//       desc: "Create events, manage RSVPs and reminders for residents.",
//     },
//     {
//       icon: "bi-file-earmark-check",
//       title: "Elections & Voting",
//       desc: "Conduct secure society elections with audit trails.",
//     },
//     {
//       icon: "bi-tools",
//       title: "Complaints & Work Orders",
//       desc: "Residents raise tickets, staff resolve with SLAs & updates.",
//     },
//     {
//       icon: "bi-credit-card",
//       title: "Payments & Dues",
//       desc: "Collect maintenance and fees with automated invoicing.",
//     },



//   ];

//   const [flipped, setFlipped] = useState(() => services.map(() => false));
//   const toggleFlip = (i) =>
//     setFlipped((prev) => prev.map((f, idx) => (idx === i ? !f : f)));

//   return (
//     <section id="services" className="py-5">
//       <div className="container">
//         <div className="text-center mb-4">
//           <h2 className="fw-bold text-primary-label">Services</h2>
//           <p className="text-muted">
//             Everything your gated community needs—managed in one place.
//           </p>
//         </div>

//         {/* --- MOBILE (< md): 2×N flip grid --- */}
//         <div className="d-md-none">
//           <div className="srv-grid" role="list" aria-label="Services">
//             {services.map((s, i) => (
//               <button
//                 key={s.title}
//                 type="button"
//                 className={`flip-card ${flipped[i] ? "is-flipped" : ""}`}
//                 onClick={() => toggleFlip(i)}
//                 onKeyDown={(e) => {
//                   if (e.key === "Enter" || e.key === " ") {
//                     e.preventDefault();
//                     toggleFlip(i);
//                   }
//                 }}
//                 aria-expanded={flipped[i]}
//                 aria-label={`${s.title} details`}
//               >
//                 <div className="flip-card-inner">
//                   {/* FRONT */}
//                   <div
//                     className="flip-card-face flip-card-front"
//                     aria-hidden={flipped[i]}
//                   >
//                     <div className="srv-icon-wrap text-primary-label" aria-hidden="true">
//                       <i className={`bi ${s.icon} srv-icon`} />
//                     </div>
//                     <h5 className="srv-title">{s.title}</h5>
//                   </div>

//                   {/* BACK */}
//                   <div
//                     className="flip-card-face flip-card-back"
//                     aria-hidden={!flipped[i]}
//                   >
//                    <div> <h6 className="srv-back-title">{s.title}</h6>
//                     <p className="srv-desc text-muted">{s.desc}</p>
//                     <span className="hint">Tap to flip back</span>


//  <Link
//                       to={`/services/book/${s.slug}`}
//                       className="btn btn-outline-teal btn-sm ms-3"
//                       aria-label={`Book ${s.title}`}
//                     >
//                       Book Services
//                     </Link>
// </div>

//                   </div>

//                 </div>
//               </button>
//             ))}
//           </div>
//         </div>

//         {/* --- DESKTOP/TABLET (>= md): original Bootstrap grid --- */}
//         <div className="row g-4 d-none d-md-flex">
//           {services.map((s, i) => (
//             <div key={i} className="col-12 col-sm-6 col-lg-4">
//               <div className="card h-100 shadow-sm">
//                 <div className="card-body">
//                   <div className="d-flex align-items-center mb-2">
//                     <i
//                       className={`bi ${s.icon} text-primary-label fs-3 me-2`}
//                       aria-hidden="true"
//                     ></i>
//                     <h5 className="card-title mb-0">{s.title}</h5>
//                   </div>
//                   <p className="card-text text-muted">{s.desc}</p>
//                 </div>
// <div>
//    <Link
//                       to={`/services/book/${s.slug}`}
//                       className="btn btn-outline-teal btn-sm"
//                       aria-label={`Book ${s.title}`}
//                     >
//                       Book Services
//                     </Link>
// </div>

//               </div>
//             </div>
//           ))}
//         </div>

//       </div>
//     </section>
//   );
// };

// export default ServicesSection;

// src/pages/ServicesSection.jsx
import React, { useEffect, useMemo, useState } from "react";
import "./services.mobile.css";
import { Link } from "react-router-dom";
import { subscribeCategories } from "../../../lib/servicesApi";

/** Minimal HTML-entity decode for &amp;/&lt;/&gt;/… */
const decodeEntities = (str) =>
  String(str || "")
    .replace(/&amp;/g, "&")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/&quot;/g, '"')
    .replace(/&#039;/g, "'");

/** Slugify for URLs (pure client-side) */
const slugify = (s) =>
  decodeEntities(String(s || ""))
    .toLowerCase()
    .trim()
    .replace(/['"]/g, "")
    .replace(/&/g, "and")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

const ServicesSection = () => {
  const [cats, setCats] = useState([]);
  const [catError, setCatError] = useState(null);
  const [loading, setLoading] = useState(true);

  // Subscribe to categories
  useEffect(() => {
    setLoading(true);
    const unsub = subscribeCategories(
      (items) => {
        setCats(items || []);
        setLoading(false);
      },
      (err) => {
        setCatError(err);
        setLoading(false);
      }
    );
    return () => unsub && unsub();
  }, []);

  // Only active categories
  const activeCats = useMemo(() => (cats || []).filter((c) => c.active), [cats]);

  // Build display cards (with fallback icon & desc)
  const cards = useMemo(() => {
    return activeCats.map((c) => ({
      icon: "bi-tools", // you can map keys to nicer icons if you want
      title: decodeEntities(c.label || c.key),
      label: decodeEntities(c.label || c.key),
      catKey: c.key, // use original key for queries later
      slug: slugify(c.label || c.key),
      desc: `Browse services in ${decodeEntities(c.label || c.key)}.`, // fallback description
    }));
  }, [activeCats]);

  // Flip state one per card
  const [flipped, setFlipped] = useState([]);
  useEffect(() => setFlipped(cards.map(() => false)), [cards.length]);
  const toggleFlip = (i) =>
    setFlipped((prev) => prev.map((f, idx) => (idx === i ? !f : f)));

  return (
    <section id="services" className="">
      <div className="container">
        <div className="text-center mb-4">
          <h2 className="fw-bold text-primary-label">Services</h2>
          <p className="text-muted">Everything your gated community needs—managed in one place.</p>
        </div>

        {catError && (
          <div className="alert alert-danger">Failed to load categories: {catError.message}</div>
        )}
        {loading && (
          <div className="text-center my-4">
            <div className="spinner-border text-primary" role="status" aria-hidden="true" />
            <div className="mt-2 text-muted small">Loading categories…</div>
          </div>
        )}

        {/* --- MOBILE (< md): 2×N flip grid --- */}
        <div className="d-md-none">
          <div className="srv-grid" role="list" aria-label="Services">
            {cards.map((s, i) => (
              <button
                key={s.slug}
                type="button"
                className={`flip-card ${flipped[i] ? "is-flipped" : ""}`}
                onClick={() => toggleFlip(i)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    toggleFlip(i);
                  }
                }}
                aria-expanded={flipped[i]}
                aria-label={`${s.title} details`}
              >
                <div className="flip-card-inner">
                  {/* FRONT */}
                  <div className="flip-card-face flip-card-front" aria-hidden={flipped[i]}>
                    <div className="srv-icon-wrap text-primary-label" aria-hidden="true">
                      <i className={`bi ${s.icon} srv-icon`} />
                    </div>
                    <h5 className="srv-title">{s.title}</h5>
                  </div>

                  {/* BACK */}
                  <div className="flip-card-face flip-card-back" aria-hidden={!flipped[i]}>
                    <div>
                      <h6 className="srv-back-title">{s.title}</h6>
                      <p className="srv-desc text-muted">{s.desc}</p>
                      <span className="hint">Tap to flip back</span>
                      <Link
                        to={`/services/category/${s.slug}`}
                        className="btn btn-outline-teal btn-sm ms-3"
                        aria-label={`View ${s.title} services`}
                      >
                        View Services
                      </Link>
                    </div>
                  </div>
                </div>
              </button>
            ))}
          </div>
        </div>

        {/* --- DESKTOP/TABLET (>= md): Bootstrap grid --- */}
        <div className="row g-4 d-none d-md-flex">
          {cards.map((s) => (
            <div key={s.slug} className="col-12 col-sm-6 col-lg-4">
              <div className="card h-100 shadow-sm">
                <div className="card-body">
                  <div className="d-flex align-items-center mb-2">
                    <i className={`bi ${s.icon} text-primary-label fs-3 me-2`} aria-hidden="true"></i>
                    <h5 className="card-title mb-0">{s.title}</h5>
                  </div>
                  <p className="card-text text-muted">{s.desc}</p>
                </div>
                <div className="card-footer bg-transparent border-0 pt-0">
                  <Link
                    to={`/services/category/${s.slug}`}
                    className="btn btn-outline-teal btn-sm"
                    aria-label={`View ${s.title} services`}
                  >
                    View Services
                  </Link>
                </div>
              </div>
            </div>
          ))}

          {!loading && cards.length === 0 && !catError && (
            <div className="col-12">
              <div className="alert alert-info">No categories found yet.</div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;

